package one.healthium.log_food.ui.scan_results.components

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import loco.LOG_FOOD_LOG_TIME_FIELD_LABEL
import loco.LOG_FOOD_SCAN_RESULTS_TOTAL_LABEL
import one.healthium.log_food.ui.scan_results.ScanResultsUiState
import one.healthium.profile.ui.food.components.FoodDetailsRaw
import one.healthium.profile.ui.food.models.Units
import org.jetbrains.compose.resources.stringResource

@Composable
internal fun FoodTotalDetails(
    modifier: Modifier = Modifier,
    state: ScanResultsUiState,
    formattedDate: String,
    onLogTimeClicked: () -> Unit,
) {
    FoodDetailsRaw(
        modifier = modifier,
        title = stringResource(loco.Res.string.LOG_FOOD_SCAN_RESULTS_TOTAL_LABEL),
        carbsDisplayValue = Units.Gram.format(state.totalCarbs),
        proteinDisplayValue = Units.Gram.format(state.totalProtein),
        fatDisplayValue = Units.Gram.format(state.totalFat),
        fiberDisplayValue = Units.Gram.format(state.totalFiber),
        caloriesDisplayValue = state.totalCalories.toInt(),
        bottomContent = {
            DetailsRowInCard(
                title = stringResource(loco.Res.string.LOG_FOOD_LOG_TIME_FIELD_LABEL),
                value = formattedDate,
                onClick = onLogTimeClicked,
            )
        },
    )
}
